<!-- Navigation Banner -->
<nav class="bg-gray-800 sticky top-0 z-[9999]">
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="flex h-16 items-center">
      <div class="flex-shrink-0">
        <img class="h-10 w-auto cursor-pointer" src="/assets/Buziflow-Logo750.gif" alt="Buziflow"> 
      </div>
    </div>
  </div>
</nav>

<!-- Hero section with professional welcome message -->
<div class="bg-gradient-to-r from-black to-gray-800 text-white py-8">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1 class="text-3xl font-bold">Welcome to Our Vendor Network</h1>
    <p class="mt-2 text-lg text-gray-300">Join our trusted network of service providers and grow your business</p>
  </div>
</div>

<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
  <div class="bg-white rounded-lg shadow-lg p-8">
    <!-- Form header -->
    <div class="text-center mb-8">
      <h2 class="text-2xl font-bold text-gray-900">Gerber Vendor Registration</h2>
      <p class="text-sm text-gray-600 mt-2">Please complete all required fields marked with an <span class="text-red-500">*</span></p>
    </div>

    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="space-y-6">
      <!-- Business Information Section -->
      <div class="bg-gray-50 p-6 rounded-lg mb-8">
        <h3 class="text-xl font-semibold text-gray-900 mb-4 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          Business Information
        </h3>

        <div class="mb-4">
          <label for="tenantName" class="block text-sm font-medium text-gray-700">Business Name<span class="text-red-500">*</span></label>
          <input id="tenantName" formControlName="tenantName" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" [ngClass]="{'border-red-500': getFieldError('tenantName')}">
          <div *ngIf="getFieldError('tenantName')" class="text-red-500 text-sm mt-1">
            {{ getFieldError('tenantName') }}
          </div>
        </div>

        <div class="mb-4">
          <label for="tenantPhoneNumber" class="block text-sm font-medium text-gray-700">Business Phone<span class="text-red-500">*</span></label>
          <input 
            id="tenantPhoneNumber" 
            formControlName="tenantPhoneNumber" 
            type="text" 
            mask="(000) 000-0000"
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            [ngClass]="{'border-red-500': getFieldError('tenantPhoneNumber')}">
          <div *ngIf="getFieldError('tenantPhoneNumber')" class="text-red-500 text-sm mt-1">
            {{ getFieldError('tenantPhoneNumber') }}
          </div>
        </div>

        <div class="mb-4">
          <label for="tenantAddress" class="block text-sm font-medium text-gray-700">Address<span class="text-red-500">*</span></label>
          <input id="tenantAddress" formControlName="tenantAddress" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" [ngClass]="{'border-red-500': getFieldError('tenantAddress')}">
          <div *ngIf="getFieldError('tenantAddress')" class="text-red-500 text-sm mt-1">
            {{ getFieldError('tenantAddress') }}
          </div>
        </div>

        <div class="mb-4">
          <label for="tenantAddress2" class="block text-sm font-medium text-gray-700">Address 2</label>
          <input id="tenantAddress2" formControlName="tenantAddress2" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" [ngClass]="{'border-red-500': getFieldError('tenantAddress2')}">
          <div *ngIf="getFieldError('tenantAddress2')" class="text-red-500 text-sm mt-1">
            {{ getFieldError('tenantAddress2') }}
          </div>
        </div>

        <!-- City, State, Zip section -->
        <div class="flex flex-col md:flex-row md:space-x-4 mb-4">
          <!-- City - full width on mobile, flex-1 on desktop -->
          <div class="w-full md:flex-1 mb-4 md:mb-0">
            <label for="tenantCity" class="block text-sm font-medium text-gray-700">City<span class="text-red-500">*</span></label>
            <input 
              id="tenantCity" 
              formControlName="tenantCity" 
              type="text" 
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              [ngClass]="{'border-red-500': getFieldError('tenantCity')}">
            <div *ngIf="getFieldError('tenantCity')" class="text-red-500 text-sm mt-1">
              {{ getFieldError('tenantCity') }}
            </div>
          </div>

          <!-- State and Zip container - side by side on mobile -->
          <div class="flex space-x-4 md:flex-1">
            <div class="flex-1">
              <label for="tenantState" class="block text-sm font-medium text-gray-700">State<span class="text-red-500">*</span></label>
              <input 
                id="tenantState" 
                formControlName="tenantState" 
                type="text" 
                class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                [ngClass]="{'border-red-500': getFieldError('tenantState')}">
              <div *ngIf="getFieldError('tenantState')" class="text-red-500 text-sm mt-1">
                {{ getFieldError('tenantState') }}
              </div>
            </div>
            <div class="flex-1">
              <label for="tenantZip" class="block text-sm font-medium text-gray-700">Zip<span class="text-red-500">*</span></label>
              <input 
                id="tenantZip" 
                formControlName="tenantZip" 
                type="text" 
                class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                [ngClass]="{'border-red-500': getFieldError('tenantZip')}">
              <div *ngIf="getFieldError('tenantZip')" class="text-red-500 text-sm mt-1">
                {{ getFieldError('tenantZip') }}
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4">
          <label for="tenantWebsite" class="block text-sm font-medium text-gray-700">Website</label>
          <input id="tenantWebsite" formControlName="tenantWebsite" type="text" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
          <div *ngIf="getFieldError('tenantWebsite')" class="text-red-500 text-sm mt-1">
            {{ getFieldError('tenantWebsite') }}
          </div>
        </div>
        <div class="mb-4 hidden">
          <label for="serviceOffered" class="block text-sm font-medium text-gray-700">Service Category</label>
          <select id="serviceOffered" formControlName="serviceOffered" class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
            <option value="">Select a service</option>
            <option value="glass">Glass</option>
            <option value="sensor">Sensor</option>
            <option value="alignment">Alignment</option>
            <option value="striping">Striping</option>
          </select>
          <div *ngIf="getFieldError('serviceOffered')" class="text-red-500 text-sm mt-1">
            {{ getFieldError('serviceOffered') }}
          </div>
        </div>
      </div>

      <!-- Contact Information Section -->
      <div class="bg-gray-50 p-6 rounded-lg mb-8">
        <h3 class="text-xl font-semibold text-gray-900 mb-4 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2 text-gray-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Contact Information
        </h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="mb-4">
            <label for="userName" class="block text-sm font-medium text-gray-700">Contact Name<span class="text-red-500">*</span></label>
            <input id="userName" formControlName="userName" type="text" 
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              [ngClass]="{'border-red-500': getFieldError('userName')}">
            <div *ngIf="getFieldError('userName')" class="text-red-500 text-sm mt-1">
              {{ getFieldError('userName') }}
            </div>
          </div>

          <div class="mb-4">
            <label for="phoneNumber" class="block text-sm font-medium text-gray-700">Contact's Phone<span class="text-red-500">*</span></label>
            <input id="phoneNumber" formControlName="phoneNumber" type="text" mask="(000) 000-0000"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              [ngClass]="{'border-red-500': getFieldError('phoneNumber')}">
            <div *ngIf="getFieldError('phoneNumber')" class="text-red-500 text-sm mt-1">
              {{ getFieldError('phoneNumber') }}
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label for="userEmail" class="block text-sm font-medium text-gray-700">Email<span class="text-red-500">*</span></label>
          <input id="userEmail" formControlName="userEmail" type="email" 
            class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            [ngClass]="{'border-red-500': getFieldError('userEmail')}">
          <div *ngIf="getFieldError('userEmail')" class="text-red-500 text-sm mt-1">
            {{ getFieldError('userEmail') }}
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="mb-4">
            <label for="userPassword" class="block text-sm font-medium text-gray-700">Password<span class="text-red-500">*</span></label>
            <input id="userPassword" formControlName="userPassword" type="password" 
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              [ngClass]="{'border-red-500': getFieldError('userPassword')}">
            <div *ngIf="getPasswordError()" class="text-red-500 text-sm mt-1">
              {{ getPasswordError() }}
            </div>
          </div>

          <div class="mb-4">
            <label for="userPasswordConfirm" class="block text-sm font-medium text-gray-700">Confirm Password<span class="text-red-500">*</span></label>
            <input id="userPasswordConfirm" formControlName="userPasswordConfirm" type="password" 
              class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              [ngClass]="{'border-red-500': getFieldError('userPasswordConfirm')}">
            <div *ngIf="getPasswordMatchError()" class="text-red-500 text-sm mt-1">
              {{ getPasswordMatchError() }}
            </div>
          </div>
        </div>
      </div>

      <!-- Terms and Conditions -->
      <div class="bg-gray-100 p-4 rounded-lg mb-6">
        <p class="text-sm text-gray-700">
          By submitting this form, you agree to our Terms of Service and Privacy Policy. We'll review your application and get back to you within 2 business days.
        </p>
      </div>

      <!-- Submit Button -->
      <div class="flex justify-end">
        <button type="submit" 
          class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          Complete Registration
        </button>
      </div>
    </form>
  </div>
</div>
